import { render, staticRenderFns } from "./Turn.vue?vue&type=template&id=1eef07ee&scoped=true"
import script from "./Turn.vue?vue&type=script&lang=js"
export * from "./Turn.vue?vue&type=script&lang=js"
import style0 from "./Turn.vue?vue&type=style&index=0&id=1eef07ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eef07ee",
  null
  
)

export default component.exports